import React from 'react';

interface CompletedStepProps {
  onNext: (data: Record<string, any>) => void;
}

export const CompletedStep: React.FC<CompletedStepProps> = ({ onNext }) => {
  React.useEffect(() => {
    onNext({});
  }, [onNext]);

  return null;
};
